import { formatUnits, parseEther, readContract, writeContractAndWait } from "../viem";
import { approveToken, getTokenAllowance } from ".";
import MafiaFamilyBank from "../../abis/MafiaFamilyBank.json";
import config from "../../config/config";

const address = config.familyBankAddress;
const abi = MafiaFamilyBank;

export const approveFamilyBankContract = async (
  account: string,
  approveAmount: number
) => {
  const tokenAddress = config.mafiaAddress;
  const contractAddress = config.familyBankAddress;

  const allowance = await getTokenAllowance(
    tokenAddress,
    account,
    contractAddress
  );

  if (Number(allowance) < approveAmount) {
    await approveToken(tokenAddress, approveAmount, contractAddress, account);
  }
};

export const createStaking = async (
  account: string,
  familyId: number,
  amount: number
) => {
  const data = await writeContractAndWait({
    address,
    abi,
    functionName: "deposit",
    args: [familyId, parseEther(amount.toString())],
    account,
  });

  return data;
};

export const withdrawStaking = async (account: string, stakingId: number) => {
  const data = await writeContractAndWait({
    address,
    abi,
    functionName: "withdraw",
    args: [stakingId],
    account,
  });

  return data;
};

export const getUserStakingAmount = async (account: string) => {
  const amount: number = await readContract({
    address,
    abi,
    functionName: "userStakingAmount",
    args: [account],
    account,
  });

  return parseInt(formatUnits(amount, 18));
};

export const getLastWithdrawAt = async (account: string) => {
  const timestamp: number = await readContract({
    address,
    abi,
    functionName: "lastWithdrawAt",
    args: [account],
    account,
  });

  return Number(timestamp);
};
